/**
 * Erro de domínio. Frontend mapeia código → mensagem PT-BR em shared/i18n/.
 * Espelha o envelope RFC 7807 do backend (ver REGRAS.md §4.3).
 */
export class DomainError extends Error {
  readonly code: string;
  readonly status: number;
  readonly fieldErrors: ReadonlyArray<FieldError>;
  readonly traceId?: string;

  constructor(params: {
    code: string;
    message: string;
    status: number;
    fieldErrors?: ReadonlyArray<FieldError>;
    traceId?: string;
  }) {
    super(params.message);
    this.name = 'DomainError';
    this.code = params.code;
    this.status = params.status;
    this.fieldErrors = params.fieldErrors ?? [];
    if (params.traceId !== undefined) {
      this.traceId = params.traceId;
    }
  }

  static fromApiError(payload: unknown, fallbackStatus = 500): DomainError {
    if (payload && typeof payload === 'object') {
      const p = payload as Record<string, unknown>;
      return new DomainError({
        code: typeof p['errorCode'] === 'string' ? p['errorCode'] : 'UNKNOWN_ERROR',
        message: typeof p['detail'] === 'string'
          ? p['detail']
          : typeof p['title'] === 'string'
            ? p['title']
            : 'Erro desconhecido',
        status: typeof p['status'] === 'number' ? p['status'] : fallbackStatus,
        fieldErrors: Array.isArray(p['fieldErrors'])
          ? (p['fieldErrors'] as FieldError[])
          : [],
        ...(typeof p['traceId'] === 'string' ? { traceId: p['traceId'] } : {}),
      });
    }
    return new DomainError({
      code: 'UNKNOWN_ERROR',
      message: 'Erro desconhecido',
      status: fallbackStatus,
    });
  }
}

export interface FieldError {
  readonly field: string;
  readonly code: string;
  readonly message: string;
}
